<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Bank</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table :headers="headers" :items="bank_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Bank</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Bank</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense outlined rounded :items="bank_super_master_list"
                          v-model="addedItem.bank_super_master_list" label="Select Bank"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field dense outlined rounded v-model="editedItem.bankName" persistent-hint
                          :disabled="editedIndex != -1" :hint="
                            editedIndex == -1
                              ? 'For example :: SBI, HDFC'
                              : 'Noneditable'
                          " label="Bank"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                      <v-row>
                        <v-col v-if="editedIndex == -1">
                          <v-checkbox dense v-model="newbankcheckbox" color="success"
                            label="Bank not present in above list? Add new here..."></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && newbankcheckbox">
                          <v-text-field v-model="newbank" persistent-hint hint="For example :: SBI, HDFC"
                            label="New Bank" ref="newbank"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="newbankcheckbox">
                          <v-btn class="mb-2 button" color="primary" small @click="saveNewBank()">Save New Bank</v-btn>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" v-if="!newbankcheckbox" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      bankName: false,
    },
    // extraBreadcrumbItems: [
    //   { text: "Bank Master", disabled: true, href: "" },

    // ],

    // breadcrumbClass: "breadcrumb-style1",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    bank_super_master_list: null,
    newbankcheckbox: false,
    newbank: null,
    headers: [
      {
        text: "Bank",
        align: "left",
        sortable: false,
        value: "bankName",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    bank_list: [],
    editedIndex: -1,
    addedItem: {
      bank_super_master_list: "",
    },
    editedItem: {
      id: "",
      bankName: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      bankName: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bank" : "Edit Bank";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    saveNewBank() {
      if (this.newbank.length == 0) {
        this.showSnackbar("#b71c1c", "Please add bank!");
        this.$refs["newbank"].focus();
        return;
      }
      // alert('111'+this.newbank)
      let data = { newbank: this.newbank };
      this.overlay = true;
      axios
        .post("/AccountingAndFees/addNewBank", data)
        .then((res) => {
          (this.newbank = null),
            (this.newbankcheckbox = false),
            (this.overlay = false);
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Bank Added Successfully!!!"); // show snackbar on success
            this.onLoad();
          } else if (res.data.status.code == "NA") {
            this.showSnackbar("#b71c1c", "Bank Already Present!"); // show snackbar on error
          }
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
      this.close();
    },

    initializeErrorMsgFalse() {
      this.errorMsg.bankName = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Account/bank")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.bank_super_master_list = res.data.bank_super_master_list;
              this.bank_list = res.data.bank_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.bank_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Account/editBank", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.bank_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Bank Details Updated Successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/Account/saveBank", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.bank_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Bank Details Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Bank Details Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.bankName) {
        return true;
      } else {
        if (!this.editedItem.bankName) {
          this.errorMsg.bankName = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
